module.exports = __webpack_public_path__ + "static/media/into-fight.8aa3c712.mp3";